import React, { useState, useEffect, useRef } from 'react';

const GeneratorOutput = ({ isDarkMode, generatedContent, onClear, onCopy, onDownloadTxt, onDownloadCsv, isLoading, progress }) => {
  const outputRef = useRef(null);
  const [displayContent, setDisplayContent] = useState('');
  const [originalContent, setOriginalContent] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const typingIntervalRef = useRef(null); // Referencia para el intervalo de escritura

  useEffect(() => {
    if (generatedContent) {
      // Si hay contenido generado, detener cualquier escritura en curso
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
        typingIntervalRef.current = null;
      }
      setDisplayContent(generatedContent);
      setOriginalContent(generatedContent);
      setSearchQuery(''); // Reset search when new content is generated
    } else {
      // Initial placeholder text
      const initialText = `Iniciando Gen CC Ultimate...\n\n> Sistema iniciado correctamente\n> Listo para generar BINs\n> Esperando instrucciones del usuario...\n> \n> Nota: Los datos aparecerán aquí cuando\n> se complete la generación\n>_`;
      setDisplayContent(''); // Limpiar antes de escribir
      setOriginalContent(initialText); // Guardar el original para la búsqueda
      typeWriterEffect(initialText);
    }
  }, [generatedContent]);

  useEffect(() => {
    filterCards();
  }, [searchQuery, originalContent]);

  const typeWriterEffect = (text) => {
    let i = 0;
    // Limpiar cualquier intervalo anterior antes de iniciar uno nuevo
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
    }
    
    typingIntervalRef.current = setInterval(() => {
      if (i < text.length) {
        setDisplayContent(text.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingIntervalRef.current);
        typingIntervalRef.current = null;
      }
    }, 50);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filterCards = () => {
    if (!searchQuery) {
      setDisplayContent(originalContent);
      return;
    }

    const lines = originalContent.split('\n');
    const filteredLines = lines.filter(line => 
      line.toLowerCase().includes(searchQuery.toLowerCase())
    );

    setDisplayContent(filteredLines.join('\n') + 
      `\n\n> Filtro aplicado: "${searchQuery}"\n> Mostrando ${filteredLines.length} de ${lines.length} líneas`);
  };

  return (
    <div className="col-md-6">
      <h3 className={`mb-4 font-['Orbitron'] font-bold text-xl ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
        <i className="fas fa-terminal mr-2"></i>Terminal
      </h3>
      
      <textarea 
        className={`output-area w-full p-5 font-['Courier_New'] text-sm leading-relaxed min-h-[400px] max-h-[600px] overflow-y-auto resize-none rounded-lg border-2 ${isDarkMode ? 'bg-gray-900 text-green-400 border-green-600 shadow-green-glow' : 'bg-gray-900 text-green-400 border-green-600 shadow-green-glow'}`}
        id="generatedCards" 
        placeholder="Iniciando Gen CC Ultimate..."
        readOnly
        value={displayContent}
        ref={outputRef}
      ></textarea>

      <div className="flex justify-center flex-wrap gap-3 mt-4">
        <button 
          className="btn-futuristic bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105" 
          onClick={onClear}
        >
          <i className="fas fa-trash-alt mr-2"></i>Limpiar
        </button>
        <button 
          className="btn-futuristic bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105" 
          onClick={() => onCopy(displayContent)}
        >
          <i className="fas fa-copy mr-2"></i>Copiar
        </button>
        <button 
          className="btn-futuristic bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105" 
          onClick={() => onDownloadTxt(displayContent)}
        >
          <i className="fas fa-download mr-2"></i>TXT
        </button>
        <button 
          className="btn-futuristic bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105" 
          onClick={() => onDownloadCsv(displayContent)}
        >
          <i className="fas fa-file-csv mr-2"></i>CSV
        </button>
      </div>

      {isLoading && (
        <div className="text-center mt-4">
          <div className="futuristic-spinner w-8 h-8 border-2 border-blue-400 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
          <div className="progress-futuristic mt-3 bg-gray-700 rounded-full h-2 overflow-hidden">
            <div className="progress-bar-futuristic bg-gradient-to-r from-blue-400 to-purple-500 h-full rounded-full" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneratorOutput;